import Store from "../../../../../../Store";

import lt from "./images/lt.png";
import hu from "./images/hu.png";

export const mockImages = { lt, hu };

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
